import React, {useEffect, useState} from 'react';
import EmployeesInput from "./EmployeesInput";
import LimitsView from "./LimitsView";

function EmployeesInformationForm({data, setData, setValidData, employeesList}) {
    const [limits, setLimits] = useState([]);
    const [employees, setEmployees] = useState([]);

    useEffect(() => {
        if (employeesList) {
            const newEmployees = [...employees, employeesList];
            setEmployees(newEmployees);
        }
    }, [employeesList]);


    useEffect(() => {
        setData({
            ...data,
            EmployeeLimitations: limits
        });
    }, [limits]);

    useEffect(() => {
        setData({
            ...data,
            EmployeeInformation: employees
        });
    }, [employees]);


    return (
        <>
            <div className="header">Create Employee Access</div>
            <div className="form-container">
                <div className="form-title">
                    EMPLOYEES INFORMATION
                </div>

                <div className="form-group">
                    <EmployeesInput data={employees} setData={setEmployees}/>
                </div>

                <div className="form-group">
                    <LimitsView setLimits={setLimits} setValidLimits={setValidData}/>
                </div>

            </div>
        </>
    );
}

export default EmployeesInformationForm;

